class Accordion {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll('[accordion-item]');
    this.init();
  }

  init() {
    this.items.forEach(item => {
      const header = item.querySelector('[accordion-header]');
      const content = item.querySelector('[accordion-content]');

      this.updateHeight(item);

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');

        this.items.forEach(i => i.classList.remove('active'));

        if (!isOpen) {
          item.classList.add('active');
          this.updateHeight(item);
        }
      });

      // Recalcul après chargement des images
      content.querySelectorAll('img').forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', () => this.updateHeight(item));
        }
      });
    });

    // Resize global
    window.addEventListener('resize', this.onResize.bind(this));
  }

  updateHeight(item) {
    const content = item.querySelector('[accordion-content]');
    const height = content.scrollHeight;
    item.style.setProperty('--open-max-height', `${height}px`);
  }

  onResize() {
    this.items.forEach(item => {
      if (item.classList.contains('active')) {
        this.updateHeight(item);
      }
    });
  }
}

const initCarousels = (rootElm = document) =>  {
    document.querySelectorAll('[accordion]').forEach(accordion => {
        new Accordion(accordion);
    });
}

window.addEventListener('DOMContentLoaded', () => {
  initCarousels()
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
    document.addEventListener('shopify:section:reorder', () => initCarousels(document));
}
